import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ImpressoraDTO, ImpressoraResponseDTO } from '../../models/impressora.models';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ImpressoraService {
  private baseUrl = '/impressora';

  constructor(private apiService: ApiService) { }

  get(url: string, data?: any): Observable<ImpressoraDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<ImpressoraDTO>(path);
  }

  getById<T>(url: string): Observable<ImpressoraResponseDTO> {
      return this.apiService.read<ImpressoraResponseDTO>(url);
    }
  
    post<T>(
      url: string,
      data: ImpressoraDTO | undefined
    ): Observable<ImpressoraDTO> {
      return this.apiService.create<ImpressoraDTO>(url, data);
    }
  
    put<T>(
      url: string,
      data: ImpressoraResponseDTO
    ): Observable<ImpressoraResponseDTO> {
      return this.apiService.update<ImpressoraResponseDTO>(url, data);
    }
  
    delete<T>(url: string): Observable<any> {
      return this.apiService.delete(url);
    }

}
